import { Navbar, Footer } from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Map, TreePine, ArrowRight } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useSeo } from "@/hooks/useSeo";

const tools = [
  {
    id: "arearaknare",
    icon: Map,
    title: "Arearäknare",
    description: "Beräkna ytan på ditt skogsområde. Rita ett polygon på kartan och få arean direkt.",
    status: "available" as const,
    href: "/skogsverktyg/arearaknare",
  },
  {
    id: "tradraknare",
    icon: TreePine,
    title: "Trädräknare",
    description: "Räkna träd i ett valt område med hjälp av AI och satellitbilder. Få en uppskattning av trädbeståndet.",
    status: "coming-soon" as const,
  },
];

export default function Tools() {
  useSeo({
    title: "Skogsverktyg — digitala verktyg för skogsägare",
    description: "Smarta digitala verktyg för dig som äger skog: areakalkylator, trädräknare och fler verktyg som förenklar skogsbruket.",
    path: "/skogsverktyg",
  });
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  const handleWaitlist = (toolName: string) => {
    if (!email) {
      toast.error("Ange din e-postadress");
      return;
    }
    toast.success(`Du är nu anmäld till väntelistan för ${toolName}!`);
    setEmail("");
  };

  return (
    <div className="flex min-h-screen flex-col">
      <Navbar />
      <div className="container flex-1 py-8">
        <h1 className="mb-1 font-display text-2xl font-bold md:text-3xl">Digitala verktyg</h1>
        <p className="mb-8 text-sm text-muted-foreground">Smarta verktyg för skogsägare</p>

        <div className="grid gap-6 md:grid-cols-2">
          {tools.map((tool) => (
            <div key={tool.id} className="rounded-lg border border-border bg-card p-6 shadow-card">
              <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10">
                <tool.icon className="h-6 w-6 text-primary" />
              </div>
              <h2 className="mb-2 font-display text-xl font-bold">{tool.title}</h2>
              <p className="mb-4 text-sm text-muted-foreground">{tool.description}</p>

              {tool.status === "available" ? (
                <Button onClick={() => navigate(tool.href!)}>
                  Öppna <ArrowRight className="ml-1 h-4 w-4" />
                </Button>
              ) : (
                <div className="rounded-md bg-secondary p-4">
                  <p className="mb-3 text-sm font-medium">🚧 Kommer snart</p>
                  <p className="mb-3 text-xs text-muted-foreground">
                    Anmäl dig till väntelistan för att bli först med att testa.
                  </p>
                  <div className="flex gap-2">
                    <Input
                      type="email"
                      placeholder="din@email.se"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="flex-1"
                    />
                    <Button size="sm" onClick={() => handleWaitlist(tool.title)}>
                      Anmäl <ArrowRight className="ml-1 h-3 w-3" />
                    </Button>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
      <Footer hideOnMobile />
    </div>
  );
}
